module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAlklEQVQYV23MvQ3CMBAF4PMPC6TzAkg0MEf2cHFNMoNnSGTLtjwHsAa0DOAKFsDWIUeAAPGqd0+fjoUQ9gDQw/8cmLV2I6U8AcDqx9xLKTvWRu/9xBgbPgERzYg4LiCl1NVaLwDQPdFVCLHWWt8W0BJjHIhoap2IRkScW38DY4xUSp3bmHPeGmPKF2iHc67nnBMiHl+fH6g1M3FrJLZSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fresh/jt.png
// module id = HdxO
// module chunks = 1